<template>
  <div class='animated fadeIn'>
    <b-card v-if="$route.name === 'User Profile'" :title="'User Profile'" sub-title="">
      <b-col lg='12'>
        <b-form-row class="form-detail">
          <b-col lg="6">
            <b-form-group
              label="Email"
              label-for="email"
              label-class="font-weight-bold"
              :horizontal="true">
              <label class="top-padding-6">{{ $store.getters.accountData.email }}</label>
            </b-form-group>
            <b-form-group
              label="First Name"
              label-for="firstName"
              label-class="font-weight-bold"
              :horizontal="true">
              <label class="top-padding-6">{{ $store.getters.accountData.firstName }}</label>
            </b-form-group>
            <b-form-group
              label="Last Name"
              label-for="lastName"
              label-class="font-weight-bold"
              :horizontal="true">
              <label class="top-padding-6">{{ $store.getters.accountData.lastName }}</label>
            </b-form-group>
            <b-form-group
              label="Phone"
              label-for="phone"
              label-class="font-weight-bold"
              :horizontal="true">
              <label class="top-padding-6">{{ $store.getters.accountData.phone !== null ? $store.getters.accountData.phone : '-' }}</label>
            </b-form-group>
            <b-form-group
              label="Mobile"
              label-for="mobile"
              label-class="font-weight-bold"
              :horizontal="true">
              <label class="top-padding-6">{{ $store.getters.accountData.mobile !== null ? $store.getters.accountData.mobile : '-' }}</label>
            </b-form-group>
            <b-form-group
              label="Account"
              label-for="account"
              label-class="font-weight-bold"
              :horizontal="true">
              <label class="top-padding-6">{{ $store.getters.accountData.account.name }}</label>
            </b-form-group>
            <b-form-group
              label="Timezone"
              label-for="timezone"
              label-class="font-weight-bold"
              :horizontal="true">
              <label class="top-padding-6">{{ $store.getters.accountData.account.timezone }}</label>
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-col><!--/.col-->
      <div slot="footer">
        <b-row>
          <b-col md="6" class="d-md-down-none">
            <b-button
              href="#/profile/password"
              size="md"
              variant="primary"
              class="btn-pill">
              <i class="fa fa-cog"></i> Change Password
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card><!--/.row-->
    <router-view></router-view>
  </div>
</template>

<script>
// custom method

export default {
  name: 'ProfileOverview'
}
</script>


// WEBPACK FOOTER //
// src/views/user-profile/Overview.vue